module.exports = __webpack_public_path__ + "img/IMG-20200128-WA0007.e143e663.jpg";